<template>
  <div :id="`banner${adCode}`"></div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
export default {
  name: 'Admodel',
  props: ['adCode'],
  data () {
    return {}
  },
  mounted () {
    this.showAdv()
  },
  computed: {
    cityId () {
      return this.soukecityId
    },
    ...mapState(['soukecityId'])
  },
  watch: {
    cityId (newVal) {
      if (newVal) {
        this.showAdv()
      }
    }
  },
  methods: {
    showAdv () {
      let adBanner = $(`#banner${this.adCode}`)
      let adCode = this.adCode
      adCode = String(adCode)
      if (adCode !== 'null') {
        adCode = adCode.indexOf('_') === -1 ? adCode : adCode.split('_')[0]
        this.getAdv(adBanner, adCode, this.cityId)
      }
    },
    getAdv: (dom, positionId, areaId) => {
      areaId = parseInt(areaId)
      var xdfAdvContainer
      if (isNaN(areaId)) {
        areaId = 0
      }
      xdfAdvContainer = (typeof xdfAdvContainer !== 'undefined' && xdfAdvContainer.constructor === Array ? xdfAdvContainer : [])
      var key = positionId + '_' + areaId
      xdfAdvContainer.push(key)
      $.get('http://web.xdf.cn/adv/index/index?position_id=' + positionId + '&area_id=' + areaId, null, function (msg) {
        if (msg.status === 1) {
          // console.log(msg)
          dom.html(msg.message)
        }else{
          if(Number(positionId)==639){
            dom.html('<img src="http://file.xdf.cn/uploads/200707/1368_20200707170628.png" alt="倒计时" />')
          }
        }
      }, 'jsonp')
    }
  }
}
</script>

<style lang="stylus" scoped>
div >>> div
  margin: 0 auto
</style>



// WEBPACK FOOTER //
// src/common-components/AdModel.vue